import Modal from 'react-native-modal';
import React, { useCallback } from 'react';
import { useWindowDimensions, View, Image, Text } from 'react-native';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import styles from '@stylesheet';
import { GoogleDrive } from '@assets/--native';
import * as Animatable from 'react-native-animatable';
import GoogleButton from '@navigation/screens/TopLevel/Components/Authorisation/GoogleButton';

type GoogleDiveModal = {
  visible: boolean,
  setVisible: Function
}

const GDriveModal = ({ visible, setVisible }: GoogleDiveModal) => {
  const dimensions = useWindowDimensions();
  const theme = useSelector((state: DefaultRootState) => state.app.theme?.lightTheme);

  const _handleSetVisible = useCallback(() => {
    setVisible(false)
  }, [])

  return (
    <Modal
      isVisible={visible}
      onBackdropPress={_handleSetVisible}
      deviceWidth={dimensions.width}
      deviceHeight={dimensions.height}
      hasBackdrop={true}
      coverScreen={true}
      backdropOpacity={.4}
      backdropColor='black'
      animationOut={'slideOutLeft'}
      animationIn={'slideInLeft'}>
      <View style={[styles.modalContainerAuth, { backgroundColor: theme ? 'white' : 'grey', zIndex: 1000, padding: 40, gap: 30 }]} >
        <Animatable.View useNativeDriver animation={'slideInDown'} style={{ flex: 1, maxHeight: 200 }}>
          <GoogleDrive width={150} height={140} />
        </Animatable.View>
        <Text>Authenticate your Google Drive to access your files</Text>
        <GoogleButton scopes={['https://www.googleapis.com/auth/drive']} setVisible={setVisible} />
      </View>
    </Modal>
  )

}

export default GDriveModal;